module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "con"
    }
  }), _c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intro#int"
    }
  }, [_c('strong', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter001#ch1"
    }
  }, [_c('strong', [_vm._v("THE SUBJECT IS CLOSED")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter002#ch2"
    }
  }, [_c('strong', [_vm._v("GRAMMAR LESSON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter003#ch3"
    }
  }, [_c('strong', [_vm._v("ASSIMILATING OUR CULTURE, THAT’S WHAT THEY’RE DOING!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE SCHUMANN COMPUTER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE GREEN MARAUDER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter006#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE REAL THING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter007#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("WAR MOVIE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter008#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("LIMITS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter009#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("TABLE MANNERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("ONE NIGHT AT THE DRACO TAVERN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter011#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE HEIGHTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter012#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE WISDOM OF DEMONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter013#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SMUT TALK")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter014#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SSOROGHOD’S PEOPLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter015#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE MISSING MASS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter016#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE CONVERGENCE OF THE OLD MIND")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter017#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CHRYSALIS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter018#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE DEATH ADDICT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter019#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("STORM FRONT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter020#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE SLOW ONES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter021#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CRUEL AND UNUSUAL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter022#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE ONES WHO STAY HOME")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter023#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("BREEDING MAZE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter024#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PLAYHOUSE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter025#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("LOST")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter026#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("LOSING MARS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter027#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PLAYGROUND EARTH")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ee5fb14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 78
// module chunks = 0